var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-crud',{ref:"suporte",attrs:{"caption":"Chamados de suporte","singular":"Chamado de suporte","captionAdd":"Novo chamado","deletable":false,"showUnique":false,"iconFavorite":false,"showAutoSave":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }